import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const Lookup = () => (
  <ComponentDocs name="<Lookup/>" entry="Lookup" propsEntry="LookupProps">
    <ComponentExample
      name="Basic lookup"
      import={import("examples/Lookups/Lookup/BasicLookupExample")}
      rawImport={import("examples/Lookups/Lookup/BasicLookupExample?raw")}
    />
    <ComponentExample
      name="Lookup params"
      import={import("examples/Lookups/Lookup/LookupParamsExample")}
      rawImport={import("examples/Lookups/Lookup/LookupParamsExample?raw")}
    />
    <ComponentExample
      name="Auto lookup registration"
      import={import("examples/Lookups/Lookup/AutoLookupRegistrationExample")}
      rawImport={import(
        "examples/Lookups/Lookup/AutoLookupRegistrationExample?raw"
      )}
    />
  </ComponentDocs>
);

export default Lookup;
